import { Location } from '@prenuvo/halo-icon';
import { SelectField } from '@prenuvo/halo-web';
import { isResearchOnlyLocation } from '@/utils/replaceLocationBasedTerms';
import { ResearchOnlyLocation } from '..';
import { ClinicOption } from './ClinicSelectOption';
import { useClinicLocationsDropdown } from '@/hooks';

const ClinicLocationsDropdown = () => {
  const { locationOptions, location, locations, handleSelect } = useClinicLocationsDropdown();

  return (
    <div className="section-locations">
      <h2 className="section-title">Scan Location</h2>
      <p className="mb-6">Select a location for your scan.</p>
      <div className="w-full sm:max-w-[340px]">
        <SelectField
          options={locationOptions.map(({ address, clinic, id }) => ({
            children: <ClinicOption address={address} clinic={clinic} />,
            value: id,
          }))}
          value={location?.code}
          onChange={handleSelect}
          name="location"
          leftIcon={() => <Location />}
          isLoading={locations.length === 0}
          className={{
            root: 'mb-0',
          }}
        />
      </div>
      {location?.code && isResearchOnlyLocation(location.code) ? (
        <ResearchOnlyLocation location={location} />
      ) : null}
    </div>
  );
};

export default ClinicLocationsDropdown;
